import './styles/index.less';
import App from 'fude/fude-web-vue';
import context from './context';
import components from './components';
import consts from './consts';

export default App
    .settings({
        localization : {
            current    : 'ru',
            target     : 'exchange-web',
            dateFormat : 'DD.MM.YYYY HH:mm'
        },
        sockets : {

        }
    })
    .consts(consts)
    .context(context)
    .components(
        components.MainMenu,
        components.BalanceMenu,
        components.ReturnedMenu,
        components.Drawer,
        components.Content,
        components.Footer,
        components.DateField,
        components.LidList
    );